import { InjectionToken } from '@angular/core';
import { Resolvers } from '@apollo/client/core';

import { DocumentNode } from 'graphql';
import { DatiqGraphqlPageDirection } from './datiq-graphql.enum';
import {
    IDatiqGraphQlPage,
    IDatiqGraphQlPageCurrent,
} from './datiq-graphql.interface';

export type Maybe<T> = T | null;
export type Exact<T extends { [key: string]: unknown }> = {
    [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> &
    { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> &
    { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
    ID: string;
    String: string;
    Boolean: boolean;
    Int: number;
    Float: number;
    Upload: any;
};

export const DATIQ_GRAPH_QL_MOCK_CONFIG_TOKEN = new InjectionToken(
    'Graph Ql Mock'
);

export class DatiqGraphQlMockConfig {
    typeDefs: DocumentNode[] = [];
    resolvers?: Resolvers[] = [];
}

export const getTypeDefsFromConfigs: (
    configs: DatiqGraphQlMockConfig[]
) => DocumentNode[] = (configs: DatiqGraphQlMockConfig[]): DocumentNode[] => {
    return configs.reduce(
        (
            typeDefs: DocumentNode[],
            config: DatiqGraphQlMockConfig
        ): DocumentNode[] =>
            !!config?.typeDefs?.length
                ? [...typeDefs, ...config?.typeDefs]
                : [...typeDefs],
        []
    );
};
export const getResolversFromConfigs: (
    configs: DatiqGraphQlMockConfig[]
) => Resolvers[] = (configs: DatiqGraphQlMockConfig[]): Resolvers[] => {
    return configs.reduce(
        (resolvers: Resolvers[], config: DatiqGraphQlMockConfig): Resolvers[] =>
            !!config.resolvers?.length
                ? [...resolvers, ...config?.resolvers]
                : [...resolvers],
        []
    );
};

export const emptyDatiqGraphQlPage: IDatiqGraphQlPage = {
    page: 0,
    size: 0,
    sortBy: '',
    direction: DatiqGraphqlPageDirection.Asc,
};
export const emptyDatiqGraphQlPageCurrent: IDatiqGraphQlPageCurrent = {
    index: 0,
    size: 0,
    pages: 0,
    elements: 0,
};
